import {BehaviorSubject} from 'rxjs';

export const innerWidth$ = new BehaviorSubject(1200);
export const innerHeight$ = new BehaviorSubject(768);
